import React, { useState, useEffect } from "react";
import "./intro.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";

import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback


function Intro({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [rules, setRules] = useState(["", "", ""]);
  const [initialFund, setinitialfundData] = useState(null);
  const [balance, setbalancefundData] = useState(null);
  const [textcolor, Setcolorcode] = useState(null);


  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/login?save=true"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
            const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        setRules(parsedTheme.rules); // ✅ Set rules correctly
        Setcolorcode(parsedTheme.landing_page_title_color);
        console.log("Theme Rules:", parsedTheme.rules);
      } else {
      navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();
  }, [database, navigate]);

  useEffect(() => {
    if (!themeData || !userData) return;

    const gameRef = doc(database, `sessions/${userData.sessionId}/themes/${themeData.themeName}`);

    const unsubscribe = onSnapshot(gameRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const gameData = docSnapshot.data();
        console.log("Game Data:", gameData);

        //setinitialfundData(gameData.initialfund);
        //setbalancefundData(gameData.initialfund);

        // ✅ Check & create user AFTER initial fund is set
        //checkAndCreateUser(userData, gameData.initialfund, gameData.initialfund);
      } else {
        console.warn("Game session document does not exist.");
      }
    });

    return () => unsubscribe();
  }, [database, themeData, userData]); // ✅ Removed unnecessary dependencies

  useEffect(() => {
    if (themeData != null) {
      const body = document.body;

      if (body.classList.contains('common-bg')) {
        // Check if it's a mobile device (or you can define your own breakpoint)
        if (window.innerWidth <= 768) {
          // Apply mobile background
          console.log(themeData.background_mob);
          body.style.backgroundImage = `url(${themeData.background_mob})`;
        } else {
          // Apply desktop background
          console.log(themeData.background_desk);
          body.style.backgroundImage = `url(${themeData.background_desk})`;
        }
      }

      SetriddlerusLogo(themeData.logo);
    }
  }, [themeData]);

  return (
    <>
      <div className="intro-main-container" style={{ textAlign: "center" }}>
        <div className="intro-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="login-logo" />
        </div>

        <div className="text-main-container" style={{ textAlign: "center" }}>
          <h4 style={{ color: textcolor }} id="introtext">RULES</h4>
        </div>

        <div>
          <ul className="rules">
            {rules.map((rule, index) => (
              <li style={{ color: textcolor }} key={index}>{rule || "N/A"}</li> // Show "N/A" if rule is empty
            ))}
          </ul>
        </div>

        <div style={{ textAlign: "center" }}>
          <Link to="/game">
            <img src="/img/next-button.png" className="begin-play-img" />
          </Link>
        </div>
      </div>

    </>

  );
}
export default Intro;